import { useEffect, useState } from 'react';
import { ComponentConfig, FieldLabel } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../page-builder/puck/reusable-props/margin';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import CustomTooltip from '../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../services/constants';
import { CustomizeProps } from '../../interface/commonInterface';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import {
  getBorderProps,
  getcurrentDeviceType,
  getFontSize,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import {
  textAlignField,
  TextAlignProps,
} from '../../puck/reusable-props/text-align';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import CustomizeIcon, { ICustomIconValueProps } from './CustomizeIcon';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import { Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import QuilHelper from '../../puck/reusable-props/quilHelper';
import WithAccordion from '../customComponents/CustomAccordion';
import '../text-editor/style.scss';
import { ToggleButtonGroup, ToggleButton, TextField } from '@mui/material';
import { JustifyOptions, toolTipInfo } from '../../utils/constants';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import { widthOptions } from '../../puck/reusable-props/width';
import { Select } from '../../../page-builder/components/form-fields/Select';
import JustifyContent, {
  IJustifyContentProps,
} from '../blocks/Container/justify-content';
export type TimerProps = {
  background: {
    color: string;
    isInherit: boolean;
  };
  interval: number;
  sale: CustomizeProps;
  body: CustomizeProps;
  customIcon: ICustomIconValueProps;
  customCountDown: {
    addHours: boolean;
    addMSeconds: boolean;
    hideColons: boolean;
  };
  customTimerLabel: {
    hours: string;
    minutes: string;
    seconds: string;
    milliseconds: string;
  };
  timerLabel: CustomizeProps;
  countDown: CustomizeProps;
  border: IBorderValueProps;
  postTimer: {
    delay: number;
    showPostTimer: boolean;
    postTimerText: string;
  };
  customContent: {
    width: string;
    justifyContent: string;
  };
  timerSuffix: string;
  justifyTimer: IJustifyContentProps;
} & MarginProps &
  PaddingProps &
  showComponentProps &
  TextAlignProps;

export const Timer = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<TimerProps> => {
  return {
    label: (
      <CustomTooltip title="Timer">
        <span>Timer</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        label: 'Border',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={value => onChange({ ...value })}
            title="Border"
          />
        ),
      },
      ...backgroungFields,
      sale: {
        type: 'custom',
        label: 'Sale Text',
        render: ({ value, onChange, field }) => (
          <TextCustomInput
            showComponent={true}
            value={value}
            onChange={onChange}
            title={field?.label}
          />
        ),
      },
      body: {
        type: 'custom',
        label: 'Body Text',
        render: ({ value, onChange, field }) => (
          <TextCustomInput
            showComponent={true}
            value={value}
            onChange={onChange}
            title={field?.label}
          />
        ),
      },
      customCountDown: {
        type: 'custom',
        label: 'Custom Countdown',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Custom Countdown">
              <>
                {/* Add Hours Option */}
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={
                            'Include Hours in Countdown' as keyof typeof toolTipInfo
                          }>
                          <span>Include Hours</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <div className="w-full p-2">
                      <ToggleButtonGroup
                        value={value?.addHours}
                        exclusive
                        className="w-full"
                        onChange={(_e, selectedValue) => {
                          if (selectedValue !== null) {
                            onChange({ ...value, addHours: selectedValue });
                          }
                        }}>
                        {[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ].map((option, index) => (
                          <ToggleButton
                            key={index}
                            size="small"
                            value={option.value}
                            disableRipple
                            aria-label={option.label}
                            className="flex-1">
                            {option.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </FieldLabel>
                </div>

                {/* Add Milliseconds Option */}
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={
                            'Include Milliseconds in Countdown' as keyof typeof toolTipInfo
                          }>
                          <span>Include Milliseconds</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <div className="w-full p-2">
                      <ToggleButtonGroup
                        value={value?.addMSeconds}
                        exclusive
                        className="w-full"
                        onChange={(_e, selectedValue) => {
                          if (selectedValue !== null) {
                            onChange({ ...value, addMSeconds: selectedValue });
                          }
                        }}>
                        {[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ].map((option, index) => (
                          <ToggleButton
                            key={index}
                            size="small"
                            value={option.value}
                            disableRipple
                            aria-label={option.label}
                            className="flex-1">
                            {option.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </FieldLabel>
                </div>
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={
                            'Hide Colons in Countdown' as keyof typeof toolTipInfo
                          }>
                          <span>Hide Colons</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <div className="w-full p-2">
                      <ToggleButtonGroup
                        value={value?.hideColons}
                        exclusive
                        className="w-full"
                        onChange={(_e, selectedValue) => {
                          if (selectedValue !== null) {
                            onChange({
                              ...value,
                              hideColons: selectedValue,
                            });
                          }
                        }}>
                        {[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ].map((option, index) => (
                          <ToggleButton
                            key={index}
                            size="small"
                            value={option.value}
                            disableRipple
                            aria-label={option.label}
                            className="flex-1">
                            {option.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </FieldLabel>
                </div>
              </>
            </WithAccordion>
          );
        },
      },
      countDown: {
        type: 'custom',
        label: 'Count Down',
        render: ({ value, onChange }) => (
          <TextCustomInput
            showComponent={true}
            title="Count Down"
            isText={false}
            value={value}
            onChange={onChange}
          />
        ),
      },
      timerLabel: {
        type: 'custom',
        label: 'Timer Label',
        render: ({ value, onChange }) => (
          <TextCustomInput
            showComponent={true}
            title="Timer Label"
            isText={false}
            value={value}
            onChange={onChange}
          />
        ),
      },
      justifyTimer: {
        type: 'custom',
        label: 'Justify Content',
        render: ({ value, onChange }) => (
          <JustifyContent
            value={value}
            onChange={onChange}
            title="Justify Timer"
          />
        ),
      },
      customTimerLabel: {
        type: 'custom',
        label: 'Customize Timer Label',
        render: ({ value, onChange }) => {
          // Define allowed keys explicitly
          type LabelKeys = 'hours' | 'minutes' | 'seconds' | 'milliseconds';

          const labels: { key: LabelKeys; label: string }[] = [
            { key: 'hours', label: 'Hours Label' },
            { key: 'minutes', label: 'Minutes Label' },
            { key: 'seconds', label: 'Seconds Label' },
            { key: 'milliseconds', label: 'Milliseconds Label' },
          ];

          return (
            <WithAccordion title="Custom Labels">
              <div className="w-full p-2 space-y-2">
                {labels?.map(({ key, label }) => (
                  <div key={key}>
                    <FieldLabel
                      label={
                        (
                          <CustomTooltip
                            title={(key as keyof typeof toolTipInfo) || ''}>
                            <span>{label}</span>
                          </CustomTooltip>
                        ) as React.ReactNode as string
                      }
                      el="div"
                      className="w-full">
                      <TextField
                        variant="outlined"
                        size="small"
                        value={value[key]}
                        onChange={e =>
                          onChange({ ...value, [key]: e.target.value })
                        }
                        placeholder={label}
                        className="w-full"
                      />
                    </FieldLabel>
                  </div>
                ))}
              </div>
            </WithAccordion>
          );
        },
      },
      ...textAlignField,
      customContent: {
        type: 'custom',
        label: 'Custom Content',
        render: ({ value, onChange }) => (
          <WithAccordion title="Custom Content">
            <div className="w-full p-2 space-y-2">
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Justify Content">
                      <span>Justify Content</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Select
                  className="pagebuilder-theme"
                  value={value?.justifyContent || ''}
                  onChange={e =>
                    onChange({
                      ...value,
                      justifyContent: e.target.value,
                    })
                  }
                  options={JustifyOptions}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Width">
                      <span>Width</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }
                el="div">
                <Select
                  className="w-full"
                  value={value?.width || ''}
                  onChange={e =>
                    onChange({
                      ...value,
                      width: e.target.value,
                    })
                  }
                  options={widthOptions}
                />
              </FieldLabel>
            </div>
          </WithAccordion>
        ),
      },
      interval: { type: 'number', label: 'Interval', min: 0 },
      customIcon: {
        type: 'custom',
        label: 'Customize Icon',
        render: ({ value, onChange }) => (
          <CustomizeIcon
            value={value}
            onChange={onChange}
            title="Customize Icon"
          />
        ),
      },
      postTimer: {
        type: 'custom',
        label: 'Post Timer',
        render: ({ value, onChange }) => (
          <WithAccordion title="Post Timer">
            <div className="flex justify-between items-center mb-3">
              <p className="text-sm font-semibold">Show Post Timer</p>
              <div className="flex gap-0.5 items-center">
                <Tooltip
                  title={`Toggle this switch to show or hide the post timer text`}
                  placement="top-start">
                  <InfoIcon fontSize="small" className="h-1 w-1" />
                </Tooltip>
              </div>
              <Switch
                checked={value?.showPostTimer}
                onChange={e => {
                  onChange({
                    ...value,
                    showPostTimer: e.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </div>
            <div className="flex justify-between items-center mt-3">
              <p className="text-sm font-semibold">Delay Post Timer Text</p>
              <div className="flex gap-0.5 items-center">
                <Tooltip
                  title={`Time in seconds before the post timer text is shown`}
                  placement="top-start">
                  <InfoIcon fontSize="small" className="h-1 w-1" />
                </Tooltip>
              </div>
            </div>
            <input
              type="number"
              min={0}
              value={value?.delay || 0}
              onChange={e =>
                onChange({ ...value, delay: Number(e.target.value) })
              }
            />
            <FieldLabel
              className="mt-3"
              label={
                (
                  <CustomTooltip title="QuillEditor">
                    <span>{`Post Timer Text`}</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }
              el="div">
              <QuilHelper
                value={value?.postTimerText}
                onChange={text => {
                  onChange({
                    ...value,
                    postTimerText: text,
                  });
                }}
                id={1}
              />
            </FieldLabel>
          </WithAccordion>
        ),
      },
      timerSuffix: {
        ...QuillTextEditor('Timer Suffix', true, 2).content,
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      background: {
        color: '#ECFEFF',
        isInherit: false,
      },
      postTimer: {
        delay: 0,
        showPostTimer: false,
        postTimerText:
          '<p style="line-height:1.5;"><span style="font-size: 14px;">Offer Ends in 00:00 Minutes!</span></p>',
      },
      interval: 10 * 60,
      sale: {
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
        deviceType: 'desktop',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        textColor: {
          mobile: '#FF0000',
          tablet: '#FF0000',
          desktop: '#FF0000',
        },
        fontSize: {
          mobile: 'text-lg',
          tablet: 'text-lg',
          desktop: 'text-lg',
        },
      },
      textAlign: 'text-center',
      customCountDown: {
        addHours: false,
        addMSeconds: false,
        hideColons: false,
      },
      customTimerLabel: {
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        milliseconds: 'Milliseconds',
      },
      timerLabel: {
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        showComponent: {
          mobile: false,
          tablet: false,
          desktop: false,
        },
        deviceType: 'desktop',
        text: '',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        fontSize: {
          mobile: 'text-lg',
          tablet: 'text-lg',
          desktop: 'text-lg',
        },
      },
      countDown: {
        timerGap: '0',
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
        deviceType: 'desktop',
        text: '',
        textColor: {
          mobile: '#FF0000',
          tablet: '#FF0000',
          desktop: '#FF0000',
        },
        fontSize: {
          mobile: 'text-lg',
          tablet: 'text-lg',
          desktop: 'text-lg',
        },
      },
      body: {
        weight: {
          mobile: 'font-normal',
          tablet: 'font-normal',
          desktop: 'font-normal',
        },
        showComponent: {
          mobile: true,
          tablet: true,
          desktop: true,
        },
        deviceType: 'desktop',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do ',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        fontSize: {
          mobile: 'text-lg',
          tablet: 'text-lg',
          desktop: 'text-lg',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      customIcon: {
        deviceType: 'desktop',
        icon: {
          mobile: false,
          tablet: false,
          desktop: false,
        },
        size: {
          mobile: '15px',
          tablet: '15px',
          desktop: '15px',
        },
        iconColor: {
          mobile: '#7e3535',
          tablet: '#7e3535',
          desktop: '#7e3535',
        },
      },
      ...borderProps,
      customContent: {
        justifyContent: 'justify-start',
        width: 'w-auto',
      },
      timerSuffix: '',
      justifyTimer: {
        deviceType: 'desktop',
        justify: {
          mobile: 'justify-center',
          tablet: 'justify-center',
          desktop: 'justify-center',
        },
      },
    },
    render: ({
      background,
      interval,
      sale,
      body,
      customCountDown,
      customTimerLabel,
      timerLabel,
      countDown,
      margin,
      showComponent,
      customIcon,
      textAlign,
      border,
      padding,
      editMode,
      postTimer,
      customContent,
      timerSuffix,
      justifyTimer,
    }) => {
      const [time, setTime] = useState(interval * 1000);
      const [delay, setDelay] = useState(postTimer?.delay * 100 || 0);
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      const state = useAppSelector(state => state);

      const newSale = {
        ...sale,
        text: getQuillEditorText(sale?.text, state),
      };
      const newCountDown = {
        ...countDown,
        text: getQuillEditorText(countDown?.text, state),
      };
      const newTimerLabel = {
        ...timerLabel,
        text: getQuillEditorText(timerLabel?.text, state),
      };
      useEffect(() => {
        const intervalId = setInterval(() => {
          setTime(prevTime => {
            if (prevTime > 0) {
              return prevTime - 10;
            } else {
              setDelay((prevDelay: number) =>
                prevDelay > 0 ? prevDelay - 1 : 0,
              );
              return 0;
            }
          });
        }, 10); // Update every 10 milliseconds

        return () => clearInterval(intervalId);
      }, []);

      const hours = Math.floor(time / 3600000); // Get hours
      const minutes = Math.floor((time % 3600000) / 60000); // Get minutes
      const seconds = Math.floor((time % 60000) / 1000); // Get seconds
      const milliseconds = Math.floor((time % 1000) / 10); // Get milliseconds
      const timerGap = getFontSize(countDown?.timerGap);

      return (
        <div
          style={{
            backgroundColor: background?.isInherit
              ? 'inherit'
              : background?.color,
            ...getBorderProps(border, currentDeviceType),
            ...marginStyles,
            ...getPaddingStyles(padding, currentDeviceType),
          }}
          className={`rounded py-1 ${showComponent?.includes(currentDeviceType) ? '' : '!hidden'} ${border?.borderStyle?.[currentDeviceType]} ${textAlign}`}>
          {time === 0 && postTimer?.showPostTimer && delay === 0 ? (
            <div
              className="pl-2 text-editor-content"
              dangerouslySetInnerHTML={{
                __html: postTimer?.postTimerText,
              }}></div>
          ) : (
            <div className={`flex flex-row ${customContent?.justifyContent}`}>
              {!customIcon?.icon?.[currentDeviceType] && (
                <p
                  className={`bg-red-700 text-white rounded-full w-3 h-3 flex items-center justify-center text-xxs flex-shrink-0 mt-3 mx-2`}
                  style={{
                    padding: customIcon?.size?.[currentDeviceType],
                    backgroundColor: customIcon?.iconColor?.[currentDeviceType],
                  }}>
                  %
                </p>
              )}
              <div className={` ${textAlign} ${customContent?.width}`}>
                {newSale?.showComponent?.[currentDeviceType] && (
                  <span
                    className={`${newSale?.weight?.[currentDeviceType]} ${newSale?.fontSize?.[currentDeviceType]}`}
                    style={{ color: newSale?.textColor?.[currentDeviceType] }}>
                    {newSale?.text}{' '}
                  </span>
                )}
                {body.showComponent?.[currentDeviceType] && (
                  <span
                    className={`${body.weight?.[currentDeviceType]} ${body.fontSize?.[currentDeviceType]}`}
                    style={{ color: body.textColor?.[currentDeviceType] }}>
                    {body.text}{' '}
                  </span>
                )}
                {newCountDown?.showComponent?.[currentDeviceType] &&
                  !newTimerLabel?.showComponent?.[currentDeviceType] && (
                    <span
                      style={{
                        color: newCountDown?.textColor[currentDeviceType],
                        display: 'inline-flex',
                        gap: timerGap,
                        alignItems: 'center',
                      }}
                      className={`${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]} text-center play-wright-hide`}>
                      {customCountDown?.addHours && (
                        <span>{hours < 10 ? `0${hours}` : hours}</span>
                      )}
                      {customCountDown?.addHours &&
                        !customCountDown?.hideColons && <span>:</span>}
                      <span>{minutes < 10 ? `0${minutes}` : minutes}</span>
                      {!customCountDown?.hideColons && <span>:</span>}
                      <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
                      {customCountDown?.addMSeconds && (
                        <>
                          {!customCountDown?.hideColons && <span>:</span>}
                          <span>
                            {milliseconds.toString().padStart(2, '0')}
                          </span>
                        </>
                      )}
                      <span
                        className="pl-1 text-editor-content"
                        dangerouslySetInnerHTML={{ __html: timerSuffix }}
                      />
                    </span>
                  )}
                {newCountDown?.showComponent?.[currentDeviceType] &&
                  newTimerLabel?.showComponent?.[currentDeviceType] && (
                    <div
                      className={`flex items-center gap-2 play-wright-hide ${justifyTimer?.justify?.[currentDeviceType]}`}
                      style={{
                        display: 'flex',
                        gap: timerGap,
                        alignItems: 'start',
                      }}>
                      {customCountDown?.addHours && (
                        <>
                          <div className="flex flex-col items-center w-auto">
                            <span
                              className={`text-center ${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                              style={{
                                color:
                                  newCountDown?.textColor[currentDeviceType],
                              }}>
                              {hours < 10 ? `0${hours}` : hours}
                            </span>
                            <span
                              className={`text-center ${newTimerLabel?.weight?.[currentDeviceType] || '0.75rem'} ${newTimerLabel?.fontSize?.[currentDeviceType] || '1rem'}`}
                              style={{
                                color:
                                  newTimerLabel?.textColor[currentDeviceType] ||
                                  '#6b7280',
                              }}>
                              {customTimerLabel?.hours || 'Hours'}
                            </span>
                          </div>

                          {!customCountDown?.hideColons && (
                            <div className="flex flex-col items-start justify-center">
                              <span
                                className={`${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                                style={{
                                  color:
                                    newCountDown?.textColor[currentDeviceType],
                                }}>
                                :
                              </span>
                            </div>
                          )}
                        </>
                      )}

                      <div className="flex flex-col items-center w-auto">
                        <span
                          className={`text-center ${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                          style={{
                            color: newCountDown?.textColor[currentDeviceType],
                          }}>
                          {minutes < 10 ? `0${minutes}` : minutes}
                        </span>
                        <span
                          className={`text-center ${newTimerLabel?.weight?.[currentDeviceType]} ${newTimerLabel?.fontSize?.[currentDeviceType]}`}
                          style={{
                            color:
                              newTimerLabel?.textColor[currentDeviceType] ||
                              '#6b7280',
                          }}>
                          {customTimerLabel?.minutes || 'Minutes'}
                        </span>
                      </div>

                      {!customCountDown?.hideColons && (
                        <div className="flex flex-col items-start justify-center">
                          <span
                            className={`${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                            style={{
                              color: newCountDown?.textColor[currentDeviceType],
                            }}>
                            :
                          </span>
                        </div>
                      )}

                      <div className="flex flex-col items-center w-auto">
                        <span
                          className={`text-center ${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                          style={{
                            color: newCountDown?.textColor[currentDeviceType],
                          }}>
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </span>
                        <span
                          className={`text-center ${newTimerLabel?.weight?.[currentDeviceType]} ${newTimerLabel?.fontSize?.[currentDeviceType]}`}
                          style={{
                            color:
                              newTimerLabel?.textColor[currentDeviceType] ||
                              '#6b7280',
                          }}>
                          {customTimerLabel?.seconds || 'Seconds'}
                        </span>
                      </div>

                      {customCountDown?.addMSeconds && (
                        <>
                          {!customCountDown?.hideColons && (
                            <div className="flex flex-col items-start justify-center">
                              <span
                                className={`${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                                style={{
                                  color:
                                    newCountDown?.textColor[currentDeviceType],
                                }}>
                                :
                              </span>
                            </div>
                          )}
                          <div className="flex flex-col items-center w-auto">
                            <span
                              className={`text-center ${newCountDown?.weight?.[currentDeviceType]} ${newCountDown?.fontSize?.[currentDeviceType]}`}
                              style={{
                                color:
                                  newCountDown?.textColor[currentDeviceType],
                              }}>
                              {milliseconds.toString().padStart(2, '0')}
                            </span>
                            <span
                              className={`text-center ${newTimerLabel?.weight?.[currentDeviceType] || '0.75rem'} ${newTimerLabel?.fontSize?.[currentDeviceType] || '1rem'}`}
                              style={{
                                color:
                                  newTimerLabel?.textColor[currentDeviceType] ||
                                  '#6b7280',
                              }}>
                              {customTimerLabel?.milliseconds || 'Milliseconds'}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
              </div>
            </div>
          )}
        </div>
      );
    },
  };
};
